import { FocusTrap, Modal } from '@mantine/core'
import { usePrevious } from '@mantine/hooks'
import StoryViewer from './StoryViewer'
import type { StoryViewerTarget } from './StoryViewerContext'
import styles from './StoryViewerModal.module.css'

export interface StoryViewerModalProps {
	target?: StoryViewerTarget
	sessionId?: number
	onDismiss: () => void
}

function getTargetKey(target: StoryViewerTarget) {
	return target.type === 'PERSONAL_STORIES'
		? `${target.type}:${target.username}`
		: `${target.type}:${target.storyId}`
}

export default function StoryViewerModal({ target, sessionId, onDismiss }: StoryViewerModalProps) {
	const previousTarget = usePrevious(target)
	const previousSessionId = usePrevious(sessionId)
	const renderedTarget = target ?? previousTarget
	const renderedSessionId = sessionId ?? previousSessionId

	return (
		<Modal
			opened={Boolean(target)}
			onClose={onDismiss}
			fullScreen
			withCloseButton={false}
			closeOnClickOutside={false}
			transitionProps={{ duration: 150, transition: 'fade' }}
			zIndex="var(--mantine-z-index-modal)"
			overlayProps={{
				backgroundOpacity: 1,
				color: 'var(--solid-bg-primary-1, #1a1a1a)',
			}}
			classNames={{ content: styles.content, body: styles.body }}
			aria-label="日记浏览器"
		>
			<FocusTrap.InitialFocus />
			{renderedTarget && (
				<StoryViewer
					key={`${getTargetKey(renderedTarget)}:${renderedSessionId}`}
					target={renderedTarget}
					onClose={onDismiss}
				/>
			)}
		</Modal>
	)
}
